import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import ChannelContext from '@jetshop/core/components/ChannelContext';

const fallbackTitle = 'Tretorn Online';
const fallbackDescription = ``;

const MetaTags = ({
  title,
  description,
  keywords,
  imageUrl,
  canonicalPath,
  ogTitle,
  ogDescription,
  ogImageUrl,
  ogType,
  twitterTitle,
  twitterDescription,
  twitterImageUrl
}) => {
  const { selectedChannel } = useContext(ChannelContext);
  return (
    <Helmet>
      <title>{title || fallbackTitle}</title>
      <meta name="description" content={description || fallbackDescription} />
      {keywords && <meta name="keywords" content={keywords} />}

      <meta property="og:title" content={ogTitle || title || fallbackTitle} />
      <meta
        property="og:description"
        content={ogDescription || description || fallbackDescription}
      />
      {(ogImageUrl || imageUrl) && (
        <meta property="og:image" content={ogImageUrl || imageUrl} />
      )}
      <meta
        property="og:url"
        content={`${selectedChannel.url}${canonicalPath && canonicalPath}`}
      />
      <meta
        property="og:locale"
        content={selectedChannel.language.culture.replace('-', '_')}
      />
      <meta property="og:type" content={ogType || 'website'} />

      <meta
        name="twitter:title"
        content={twitterTitle || title || fallbackTitle}
      />
      <meta
        name="twitter:description"
        content={twitterDescription || description || fallbackDescription}
      />
      {(twitterImageUrl || imageUrl) && (
        <meta name="twitter:image" content={twitterImageUrl || imageUrl} />
      )}
    </Helmet>
  );
};

export default MetaTags;
